import React, {Component} from 'react';

import {Card} from './components/Card';
import {CardCarousel} from '../../components/common/carousel/Carousel';
import {reactCarouselBreakPoints} from '../../utils/carousel-breakpoints';
import './styles.less';

function getCards({isMobile, data, translations}) {
    const {readMore} = translations;
    return data.map((item) => {
        const {heroUrl, overview, metaTitle, metaDescription, path} = item;

        const description = overview || metaDescription;

        return (
            <a key={data.indexOf(item)} href={path} target="_blank">
                <Card
                    key={data.indexOf(item)}
                    isMobile={isMobile}
                    title={metaTitle}
                    imgUrl={`${heroUrl}?w=228&h=228`}
                    overview={description}
                    readMore={readMore}
                />
            </a>
        );
    });
}

class ContentHubComponent extends Component {
    render() {
        const {
            contentHubData: {contentful, translations},
            isMobile,
        } = this.props;

        if (!contentful.length) {
            return null;
        }

        const cards = getCards({isMobile, data: contentful, translations});

        const breakPoints = {
            '1600': 4,
            '1200': 4,
            '992': 3,
            '768': 3,
            '480': 2,
            '0': isMobile ? 2 : 4,
        };

        return (
            <div className="container module module--no-padding content-hub-carousel">
                <div className="card-carousel ">
                    <CardCarousel
                        breakpoints={reactCarouselBreakPoints(
                            isMobile,
                            breakPoints
                        )}
                        isMobile={isMobile}
                        titleMessage={translations.heading}
                    >
                        {cards}
                    </CardCarousel>
                </div>
            </div>
        );
    }
}

export default ContentHubComponent;
